var map = {
	"./content_bg.png": 502,
	"./icon01.png": 503,
	"./icon01_highlight.png": 504,
	"./icon02.png": 505,
	"./icon02_highlight.png": 506,
	"./icon03.png": 507,
	"./icon03_highlight.png": 508,
	"./icon04.png": 509,
	"./icon04_highlight.png": 510,
	"./icon05.png": 511,
	"./icon05_highlight.png": 512,
	"./left_bg.png": 513,
	"./middle_corner.png": 514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1647;